// export const API_URL = "http://localhost:3029/api/v1/launchpad";
export const BSC_URL = "https://bscscan.com/address/";
export const ETH_URL = "https://etherscan.io/address/";
export const TRON_URL = "https://tronscan.org/#/address/";
export const TON_URL = "https://tonscan.org/address/";
export const BASE_URL = "https://basescan.org/address/";
export const API_URL ="https://api.inspad.finance/api/v1/launchpad"
